import styled from 'styled-components'

const NewsItemStyle = styled.div`
	--dateMarginBottom: var(--sp5x);
	--titleMaxWidth: var(--sp169x);
	--descriptionMaxWidth: var(--sp119x);
	--itemMarginTop: var(--sp7x);
	overflow: hidden;

	margin-top: var(--itemMarginTop);

	.short-info {
		margin-bottom: var(--itemMarginTop);
	}

	.date {
		margin-bottom: var(--dateMarginBottom);
	}

	.newsItemTitle {
		max-width: var(--titleMaxWidth);
		background-image: linear-gradient(to right, var(--cream), var(--cream) 50%, var(--orange) 50%);
		background-size: 200%;
		background-position: 0%;
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
		transition: background-position var(--trTime2);
	}

	@media (hover: hover) {
		&:hover {
			.newsItemTitle {
				background-position: -100%;
			}

			.animLine {
				transform: translateX(0%);
			}
		}
	}

	.newsItemDescription {
		max-width: var(--descriptionMaxWidth);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--dateMarginBottom: var(--sp4x);
		--titleMaxWidth: var(--sp125x);
		--descriptionMaxWidth: var(--sp88x);
		--itemMarginTop: var(--sp6x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--dateMarginBottom: var(--sp3x);
		--titleMaxWidth: var(--sp96x);
		--descriptionMaxWidth: var(--sp65x);
		--itemMarginTop: var(--sp5x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		--dateMarginBottom: var(--sp2x);
		--titleMaxWidth: var(--sp61x);
		--descriptionMaxWidth: var(--sp45x);
		--itemMarginTop: var(--sp4x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--dateMarginBottom: var(--sp2x);
		--titleMaxWidth: 100%;
		--descriptionMaxWidth: 100%;
		--itemMarginTop: var(--sp4x);

		.short-info {
			flex-direction: column;
			.newsItemDescription {
				margin-top: var(--sp3x);
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--dateMarginBottom: var(--sp2x);
		--titleMaxWidth: 100%;
		--descriptionMaxWidth: 100%;
		--itemMarginTop: var(--sp3x);

		.short-info {
			flex-direction: column;
			.newsItemDescription {
				margin-top: var(--sp2x);
			}
		}
	}
`

export default NewsItemStyle
